import { IAnalyticsAcntPage } from './adobe-analytics-model';
import config from '../config/config';

function loadAdobeScript() {
  const adobeScriptURL = `${config.adobeUrl}`;
  loadScriptFile(adobeScriptURL, document.getElementsByTagName('head')[0], true, true);
}
const loadScriptFile = (file: string, appendTo: HTMLHeadElement, async: boolean, defer: boolean) => {
  const script = document.createElement('script');

  script.src = file;

  if (async) {
    script.async = true;
  }

  if (defer) {
    script.defer = true;
  }

  appendTo?.appendChild(script);
};

const loadContent = (appendTo: any) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  appendTo?.appendChild(script);
};

const trackLoggedInUserInfo = (userId: any) => {
  if (
    (window.__GDMS_PORTAL__?.dataLayer?.user && Object.entries(window.__GDMS_PORTAL__.dataLayer.user).length === 0) ||
    (window.__GDMS_PORTAL__?.dataLayer && !window.__GDMS_PORTAL__.dataLayer.user)
  ) {
    window.__GDMS_PORTAL__.dataLayer = Object.assign({}, window.__GDMS_PORTAL__.dataLayer, {
      user: userId,
    });
    triggerEvent(`logUserInfo`);
  }
};

const trackPageInfo = (page: IAnalyticsAcntPage) => {
  if (window.__GDMS_PORTAL__?.dataLayer && page) {
    window.__GDMS_PORTAL__.dataLayer = Object.assign({}, window.__GDMS_PORTAL__.dataLayer, {
      page: page,
    });
    triggerEvent('pageNavigation');
  }
};

const trackEventInfo = ({ type, actionOn, location }: any) => {
  window.__GDMS_PORTAL__.dataLayer = Object.assign({}, window.__GDMS_PORTAL__?.dataLayer, {
    [type]: actionOn,
    location: { location },
  });
  triggerEvent(`${type}Event`);
};

const triggerEvent = (type: any) => {
  window.__GDMS_PORTAL__?.dataLayer?.analyticsEvent?.push({ type });
};

export default {
  loadContent,
  loadAdobeScript,
  trackEventInfo,
  trackLoggedInUserInfo,
  trackPageInfo,
};
